export const MENU_LIST = [
  {
    name_en: 'ChatBI',
    name_zh: 'ChatBI',
    icon: 'information-cue',
    id: '1',
    page_id: 'ChatBI',
    assembly_url: 'Action/GptAnalysis',
    env: ['pre', 'pro'],
  },
  {
    name_en: 'ChatBI - Data Analysis',
    name_zh: 'ChatBI - Data Analysis',
    icon: 'camera',
    id: '2',
    page_id: 'dataAnalysis',
    assembly_url: 'Analysis',
    env: ['pre', 'pro'],
  },
  {
    name_en: 'AI Cases&Tools',
    name_zh: 'AI应用案例库&工具集',
    icon: 'hexagon-ai',
    id: '3',
    page_id: 'aigc',
    assembly_url: 'AITools',
    env: ['pre', 'pro'],
  },
  {
    name_en: 'Long Content Summarization',
    name_zh: '长文本总结',
    icon: 'report-summarization',
    id: '4',
    page_id: 'report-summariy',
    assembly_url: 'report-summary',
    env: ['pre', 'pro'],
  },
  {
    name_en: 'Text2SQL',
    name_zh: 'Text2SQL',
    icon: 'aigc-sql',
    id: '5',
    page_id: 'text2sql',
    assembly_url: 'Text2SQL',
    env: ['pre', 'pro'],
  },
  {
    name_en: 'GPT Translator',
    name_zh: 'GPT Translator',
    icon: 'translate',
    id: '6',
    page_id: 'GPT Translator',
    assembly_url: 'GPTTranslator',
    env: ['pre', 'pro'],
  },
  {
    name_en: 'Motion Capture',
    name_zh: 'Motion Capture',
    icon: 'motion-capture-icon',
    id: '7',
    page_id: 'motion-capture',
    assembly_url: 'motion-capture',
    env: ['pre', 'pro'],
  },


];
